// @flow
import { Arrow, Container, TextContainer } from './style';
import { getControlPanelHeight, getSelectedDayHeight, getTimeAxisHeight, getWeekHeight } from '../utils';
import { injectIntl, intlShape } from 'react-intl';

import ImmutablePropTypes from 'react-immutable-proptypes';
import messages from '~/core/domains/schedule/intl';
import PropTypes from 'prop-types';
import * as React from 'react';

const MINUTES_IN_DAY = 1440;

Event.propTypes = {
    height: PropTypes.number.isRequired,
    intl: intlShape,
    nextEventStart: PropTypes.number,
    numEventsInSelectedDay: PropTypes.number,
    selectedDay: PropTypes.number,
    selectedEvent: ImmutablePropTypes.contains({
        eventIndex: PropTypes.number.isRequired,
        start: PropTypes.number.isRequired
    }),
    showToolTip: PropTypes.bool.isRequired,
    width: PropTypes.number.isRequired
};

function Event({
    height,
    intl: { formatMessage },
    nextEventStart,
    numEventsInSelectedDay,
    selectedDay,
    selectedEvent,
    showToolTip,
    width
}) {
    if (!showToolTip) {
        return null;
    }

    const controlPanelHeight = getControlPanelHeight(height);
    const timeAxisHeight = getTimeAxisHeight(height);
    const eventIndex = selectedEvent.get('dayIndex') === selectedDay ? selectedEvent.get('eventIndex') : -1;

    const eventMiddle = ((eventIndex > -1 ? selectedEvent.get('start', 0) : 0) + nextEventStart) / 2;
    const xPos = timeAxisHeight + Math.round(eventMiddle * (width - 2 * timeAxisHeight) / MINUTES_IN_DAY);
    const { otherDayHeight, selectedDayHeight } = getSelectedDayHeight(getWeekHeight(height), numEventsInSelectedDay);
    const yPos =
        controlPanelHeight +
        timeAxisHeight +
        Math.round(otherDayHeight * selectedDay + (eventIndex + 1.1) * selectedDayHeight / numEventsInSelectedDay);

    const arrowSize = 15;
    const textContainerWidth = controlPanelHeight * 5;
    let textContainerLeftPercent = -50;
    if (xPos - textContainerWidth / 2 < 0) {
        textContainerLeftPercent = -xPos * 100 / textContainerWidth;
    }
    if (xPos + textContainerWidth / 2 > width) {
        textContainerLeftPercent = -100 + (width - xPos) * 100 / textContainerWidth;
    }

    return (
        <Container style={{ transform: `translate3d(${xPos}px, ${yPos}px, 0)` }}>
            <Arrow arrowSize={arrowSize} />
            <div style={{ transform: `translateY(${-arrowSize}px)` }}>
                <TextContainer leftTranslation={textContainerLeftPercent} style={{ width: textContainerWidth }}>
                    {formatMessage(messages.tooltipMessage)}
                </TextContainer>
            </div>
        </Container>
    );
}

export default injectIntl(Event);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/tooltip/component.js